import PropTypes from "prop-types";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import ProductGridTwo from "./ProductGridTwo";
import ProductGridCategory from "./ProductGridCategory";
import ProductGridListSingle from "../../components/product/ProductGridListSingle";

const TabProductCategory = ({
  block,
  category,
  productTabClass
}) => {
  const [dynamicLink, setDynamicLink] = useState('/shop?category=' + encodeURI(block.category1))

  return (
    <div
      className={`product-area ${block.spaceTopClass ? block.spaceTopClass : ""} ${
        block.spaceBottomClass ? block.spaceBottomClass : ""
      }`}
    >
      <div className="container">
        <Tab.Container defaultActiveKey={block.category1} >
          <Nav
            variant="pills"
            className={`product-tab-list-2 mb-60 ${
              productTabClass ? productTabClass : ""
            }`}
          >
            <Nav.Item>
              <Nav.Link eventKey={block.category1} onSelect={() => setDynamicLink('/shop?category=' + encodeURI(block.category1))}>
                <h4>{block.category1}</h4>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey={block.category2} onSelect={() => setDynamicLink('/shop?category=' + encodeURI(block.category2))}>
                <h4>{block.category2}</h4>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey={block.category3} onSelect={() => setDynamicLink('/shop?category=' + encodeURI(block.category3))}>
                <h4>{block.category3}</h4>
              </Nav.Link>
            </Nav.Item>
          </Nav>
          <Tab.Content className="product-list-padding">
            <Tab.Pane eventKey={block.category1} >
              <h1 style={{ textAlign: 'center', marginBottom: '60px' }}>{block.category1}</h1>
                <ProductGridCategory
                  category={category}
                  type={block.category1}
                  limit={4}
                  spaceBottomClass="mb-25"
                />
            </Tab.Pane>
            <Tab.Pane eventKey={block.category2}>
            <h1 style={{ textAlign: 'center', marginBottom: '60px' }}>{block.category2}</h1>
                <ProductGridCategory
                  category={category}
                  type={block.category2}
                  limit={4}
                  spaceBottomClass="mb-25"
                />
            </Tab.Pane>
            <Tab.Pane eventKey={block.category3}>
            <h1 style={{ textAlign: 'center', marginBottom: '60px' }}>{block.category3}</h1>
                <ProductGridCategory
                  category={category}
                  type={block.category3}
                  limit={4}
                  spaceBottomClass="mb-25"
                />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
        <div className="view-more text-center mt-20 toggle-btn6 col-12">
          <Link
            className="loadMore6"
            to={process.env.PUBLIC_URL + dynamicLink}
          >
            VIEW MORE PRODUCTS
          </Link>
        </div>
      </div>
    </div>
  );
};

TabProductCategory.propTypes = {
  category: PropTypes.string,
  productTabClass: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string
};

export default TabProductCategory;
